import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const TableBulkDock = ({
  enableSelection,
  selectedRows,
  onDeselectAll,
  bulkActions,
  onBulkAction,
}) => {
  if (!enableSelection || selectedRows.size === 0) {
    return null;
  }

  return (
    <div className="bulk-actions-dock">
      <div className="bulk-actions-content">
        <span className="bulk-actions-count">
          {selectedRows.size} selected
        </span>
        <div className="bulk-actions-buttons">
          <button
            key="deselect-all"
            className="bulk-action-button deselect-button"
            onClick={onDeselectAll}
            type="button"
          >
            <FontAwesomeIcon icon={faTimes} />
            Deselect
          </button>
          {bulkActions.map(action => (
            <button
              key={action.key}
              className="bulk-action-button"
              onClick={() => onBulkAction(action)}
              type="button"
            >
              <FontAwesomeIcon icon={action.icon} />
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableBulkDock;
